import React, { useState, useEffect, useRef } from "react";
import {
  TreemapLayoutType,
  TreemapFillScaleMode,
  IgrTreemapNodeStyleMapping,
  IgrTreemap,
  IgrTreemapModule,
} from "igniteui-react-charts";

import processDataFromLocalStorage  from "../Utils/DataProcessor"
import { layoutOptions, onLayoutChange } from "../Utils/LayoutChangeLogic";

import "./treeMapGraph.css";

IgrTreemapModule.register();

/* 
  Tree map component initialised 
  < input = props >
 */

function TreeMapGraph(props) {
  // initialising usestates
  const [selectedLayout, setSelectedLayout] = useState("Squared");
  const [selectedNodeName, setSelectedNodeName] = useState("All");
  const [isClickedParentNode, setIsClickedParentNode] = useState(false);
  const [doesSelectedHaveParent, setDoesSelectedHaveParent] = useState(false);

  const treeMapRef = useRef(null);

  useEffect(() => {
    initialiseTreeMap();
  }, []);

  const initialiseTreeMap = () => {
    if (treeMapRef.current) {
      const treeMap = treeMapRef.current;
      treeMap.dataSource = processDataFromLocalStorage();
      treeMap.rootTitle = "CATEGORY";
      treeMap.fillScaleMode = TreemapFillScaleMode.Value;
      treeMap.fillScaleMinimumValue = 0;
      treeMap.fillScaleMaximumValue = 1500000000;
      treeMap.fillBrushes = "#4e62cf #8a58d6";
      treeMap.isFillScaleLogarithmic = true;
      onClickSquared();
    }
  };

  const onClickSquared = () => {
    if (treeMapRef.current) {
      const treeMap = treeMapRef.current;
      treeMap.layoutType = TreemapLayoutType.Squarified;
    }
  };

  const handleLayoutChange = (event) => {
    const newLayout = event.target.value;
    setSelectedLayout(newLayout);
    onLayoutChange(treeMapRef.current, newLayout, (newState) => {
      setSelectedLayout(newState.selectedLayout);
      setSelectedNodeName(newState.selectedNodeName);
    });
  };

  // Returns category filter based on node pressed on treemap graph
  const onNodePointerPressed = (sender, args) => {
    console.log("isClickedParentNode: ", isClickedParentNode);
    console.log("doesSelectedHaveParent: ", doesSelectedHaveParent);

    if (!args.item) {
      return;
    }

    let newSelectedNodeName = "All";
    //Reset the filter when all categories are shown
    props.resetQualityFilter();

    if (!args.item.parent) {
      // Parent node is selected
      setIsClickedParentNode(true);
      if (doesSelectedHaveParent) {
        console.log("Same parent node selected again");
        setDoesSelectedHaveParent(false);
      } else {
        console.log("Parent node selected");
        setDoesSelectedHaveParent(true);
        newSelectedNodeName = args.item.name;
      }
    } else {
      // Child node is selected
      setIsClickedParentNode(false);

      if (doesSelectedHaveParent) {
        console.log("Child node selected with previous parent");
        newSelectedNodeName = args.item.parent;
      } else {
        console.log("Child node selected");
        newSelectedNodeName = args.item.parent;
      }
    }

    setSelectedNodeName(newSelectedNodeName);
    props.onNodeSelected(newSelectedNodeName);
  };

  return (
    <>
      {/* Layout Selector */}
      <div className="options">
        <div className="option-container">
        <div className="treemap-graph-layout-selector">
        <select value={selectedLayout} onChange={handleLayoutChange}>
          {layoutOptions.map((layout) => (
            <option key={layout} value={layout}>
              {layout}
            </option>
          ))}
        </select>
        </div>
        </div>
      </div>

      {/* Treemap Component */}
      <IgrTreemap
        ref={treeMapRef}
        height="100%" 
        width="100%"
        parentIdMemberPath="parent"
        idMemberPath="id"
        labelMemberPath="name"
        valueMemberPath="quality"
        headerDisplayMode="overlay"
        overlayHeaderBackground="#FBFBFC"
        overlayHeaderHoverBackground="#F0F2F3"
        isFillScaleLogarithmic="true"
        headerDarkTextColor="#000"
        transitionDuration="300"
        rootTitle="Data"
        outline="black"
        strokeThickness={1.25}
        parentNodeBottomPadding="0"
        parentNodeLeftPadding="0"
        parentNodeRightPadding="0"
        parentNodeTopPadding="0"
        nodePointerPressed={onNodePointerPressed}
      >
        <IgrTreemapNodeStyleMapping
          name="whiteSquare"
          mappingMode="value"
          minimumValue={0}
          maximumValue={0}
          fill="#FBFBFC"
        />
        <IgrTreemapNodeStyleMapping
          name="redSquare"
          mappingMode="value"
          minimumValue={1}
          maximumValue={3}
          fill="#F40000"
          textColor="#000000"
        />
        <IgrTreemapNodeStyleMapping
          name="orangeSquare"
          mappingMode="value"
          minimumValue={4}
          maximumValue={7}
          fill="#FFA51E"
          textColor="#000000"
        />
        <IgrTreemapNodeStyleMapping
          name="greenStyle"
          mappingMode="value"
          minimumValue={8}
          maximumValue={10}
          fill="#1BC100"
          textColor="#000000"
        />
      </IgrTreemap>
    </>
  );
}

export default TreeMapGraph;
